/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./pages/__root"
import { Route as LandingRouteImport } from "./pages/landing"
import { Route as IndexRouteImport } from "./pages/index"
import { Route as ProfileIndexRouteImport } from "./pages/profile/index"
import { Route as PlansPlanIdRouteImport } from "./pages/plans/$planId"
import { Route as ProfileEditIndexRouteImport } from "./pages/profile/edit/index"
import { Route as ProfileChangePasswordIndexRouteImport } from "./pages/profile/change-password/index"
import { Route as AuthVerifyIndexRouteImport } from "./pages/auth/verify/index"
import { Route as AuthResetPasswordIndexRouteImport } from "./pages/auth/reset-password/index"
import { Route as AuthRegisterIndexRouteImport } from "./pages/auth/register/index"
import { Route as AuthLoginIndexRouteImport } from "./pages/auth/login/index"

const LandingRoute = LandingRouteImport.update({
  id: "/landing",
  path: "/landing",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: "/profile/",
  path: "/profile/",
  getParentRoute: () => rootRouteImport,
} as any)
const PlansPlanIdRoute = PlansPlanIdRouteImport.update({
  id: "/plans/$planId",
  path: "/plans/$planId",
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileEditIndexRoute = ProfileEditIndexRouteImport.update({
  id: "/profile/edit/",
  path: "/profile/edit/",
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileChangePasswordIndexRoute =
  ProfileChangePasswordIndexRouteImport.update({
    id: "/profile/change-password/",
    path: "/profile/change-password/",
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthVerifyIndexRoute = AuthVerifyIndexRouteImport.update({
  id: "/auth/verify/",
  path: "/auth/verify/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordIndexRoute = AuthResetPasswordIndexRouteImport.update({
  id: "/auth/reset-password/",
  path: "/auth/reset-password/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterIndexRoute = AuthRegisterIndexRouteImport.update({
  id: "/auth/register/",
  path: "/auth/register/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: "/auth/login/",
  path: "/auth/login/",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/landing": typeof LandingRoute
  "/plans/$planId": typeof PlansPlanIdRoute
  "/profile": typeof ProfileIndexRoute
  "/auth/login": typeof AuthLoginIndexRoute
  "/auth/register": typeof AuthRegisterIndexRoute
  "/auth/reset-password": typeof AuthResetPasswordIndexRoute
  "/auth/verify": typeof AuthVerifyIndexRoute
  "/profile/change-password": typeof ProfileChangePasswordIndexRoute
  "/profile/edit": typeof ProfileEditIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/landing": typeof LandingRoute
  "/plans/$planId": typeof PlansPlanIdRoute
  "/profile": typeof ProfileIndexRoute
  "/auth/login": typeof AuthLoginIndexRoute
  "/auth/register": typeof AuthRegisterIndexRoute
  "/auth/reset-password": typeof AuthResetPasswordIndexRoute
  "/auth/verify": typeof AuthVerifyIndexRoute
  "/profile/change-password": typeof ProfileChangePasswordIndexRoute
  "/profile/edit": typeof ProfileEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/landing": typeof LandingRoute
  "/plans/$planId": typeof PlansPlanIdRoute
  "/profile/": typeof ProfileIndexRoute
  "/auth/login/": typeof AuthLoginIndexRoute
  "/auth/register/": typeof AuthRegisterIndexRoute
  "/auth/reset-password/": typeof AuthResetPasswordIndexRoute
  "/auth/verify/": typeof AuthVerifyIndexRoute
  "/profile/change-password/": typeof ProfileChangePasswordIndexRoute
  "/profile/edit/": typeof ProfileEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/landing"
    | "/plans/$planId"
    | "/profile"
    | "/auth/login"
    | "/auth/register"
    | "/auth/reset-password"
    | "/auth/verify"
    | "/profile/change-password"
    | "/profile/edit"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/landing"
    | "/plans/$planId"
    | "/profile"
    | "/auth/login"
    | "/auth/register"
    | "/auth/reset-password"
    | "/auth/verify"
    | "/profile/change-password"
    | "/profile/edit"
  id:
    | "__root__"
    | "/"
    | "/landing"
    | "/plans/$planId"
    | "/profile/"
    | "/auth/login/"
    | "/auth/register/"
    | "/auth/reset-password/"
    | "/auth/verify/"
    | "/profile/change-password/"
    | "/profile/edit/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LandingRoute: typeof LandingRoute
  PlansPlanIdRoute: typeof PlansPlanIdRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
  AuthRegisterIndexRoute: typeof AuthRegisterIndexRoute
  AuthResetPasswordIndexRoute: typeof AuthResetPasswordIndexRoute
  AuthVerifyIndexRoute: typeof AuthVerifyIndexRoute
  ProfileChangePasswordIndexRoute: typeof ProfileChangePasswordIndexRoute
  ProfileEditIndexRoute: typeof ProfileEditIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/landing": {
      id: "/landing"
      path: "/landing"
      fullPath: "/landing"
      preLoaderRoute: typeof LandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/profile/": {
      id: "/profile/"
      path: "/profile"
      fullPath: "/profile"
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/plans/$planId": {
      id: "/plans/$planId"
      path: "/plans/$planId"
      fullPath: "/plans/$planId"
      preLoaderRoute: typeof PlansPlanIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/profile/edit/": {
      id: "/profile/edit/"
      path: "/profile/edit"
      fullPath: "/profile/edit"
      preLoaderRoute: typeof ProfileEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/profile/change-password/": {
      id: "/profile/change-password/"
      path: "/profile/change-password"
      fullPath: "/profile/change-password"
      preLoaderRoute: typeof ProfileChangePasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/verify/": {
      id: "/auth/verify/"
      path: "/auth/verify"
      fullPath: "/auth/verify"
      preLoaderRoute: typeof AuthVerifyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/reset-password/": {
      id: "/auth/reset-password/"
      path: "/auth/reset-password"
      fullPath: "/auth/reset-password"
      preLoaderRoute: typeof AuthResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/register/": {
      id: "/auth/register/"
      path: "/auth/register"
      fullPath: "/auth/register"
      preLoaderRoute: typeof AuthRegisterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/login/": {
      id: "/auth/login/"
      path: "/auth/login"
      fullPath: "/auth/login"
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LandingRoute: LandingRoute,
  PlansPlanIdRoute: PlansPlanIdRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  AuthLoginIndexRoute: AuthLoginIndexRoute,
  AuthRegisterIndexRoute: AuthRegisterIndexRoute,
  AuthResetPasswordIndexRoute: AuthResetPasswordIndexRoute,
  AuthVerifyIndexRoute: AuthVerifyIndexRoute,
  ProfileChangePasswordIndexRoute: ProfileChangePasswordIndexRoute,
  ProfileEditIndexRoute: ProfileEditIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
